import styled from "styled-components";

export const Label = styled.label`
    font-size: 14px;
    font-weight: 300;
    color: black; 
`

export const Title = styled.h5`
    font-size: 18px;
    font-weight: 400;
    margin: 8px 0px;
    color: black !important;
`

export const Link = styled.a`
    font-size: 14px;
    color: blue;
    font-weight: 300;
`

export const Devider = styled.div`
    width: 100%;
    margin: 16px 0px;
    height: 1px;
    background-color: darkgray;
`

export const TitleLinkSmall = (props: any) => (
    <Title>
        <Link href={props.href} target={props.target}>
            {props.children}
        </Link>
    </Title>
)
